<style lang='scss'>
	#handhome-est{
		.ant-modal-root .ant-modal-close-x .anticon svg{
			    font-size: 1rem !important;
				color: gray !important;
		}
	}
	
	#main-handhomes-est{
		.ant-modal-close-x{
			right: -1rem;
		}
		.ant-modal-root .ant-modal-close-x .anticon svg{
			    font-size: 1rem !important;
				color: gray !important;
		}
		.ant-modal-header, .ant-modal-body{
			border-radius:0 !important;
		}
		
		 .ant-modal-header, .ant-modal-body{
			background-color: #e5e5e5 !important;
			padding: 1rem;
			padding-top: .7rem;
		}
		
		.main-hand-title{
			position: absolute;
			top: 0;
			left: 0;
			div{
				font-size: 1rem;
				padding: .8rem 1rem .2rem 1rem;
				background-color:  #e5e5e5;
			}
		}
		
		.wland{
			display: inline-block;
			width: 8rem;
			padding: .4rem 0 .6rem;
			text-align: center;
			background-color: #fff;
			color: #000;
			border-top: .2rem solid #e99c00;
			border-right: 1px solid #e5e5e5;
			font-size: .95rem;
		}
		
		.gland{
			display: inline-block;
			width: 8rem;
			padding: .6rem 0;
			text-align: center;
			background-color: #0c8b97;
			color: #fff;
			font-size: .95rem;
			border-right: 1px solid #e5e5e5;
		}
	}
	
	#tubody-mainsk>div{
		padding: 1px 0;
		height: 22.5rem;
	}
	
	#tubody-mainsk{
		background-color: #fff;
		
		.main-mybody{
			padding: .5rem 1.5rem 0;
			overflow-y: auto;
			min-height: 12rem;
			/* min-height: 16rem;
			max-height: 16rem; */
		}
		
		.ant-empty-normal{
				margin: 7rem 0;
		}
		
		.main-wid{
			width: 85%;
			height: 1px;
			border-top: .5px solid #d8d8d8;
			margin: 1rem 0;
		}
		
		.ant-col {
			font-size: .8rem;
			color: #000;
			margin: .2rem 0;
		}
		
		.btn{
			cursor: pointer;
			width: 6rem;
			height: 2rem;
			font-size: 0.8rem;
			color: #fff;
			border: 0;
			border-radius: 5px;
			text-align: center;
			line-height: 2rem;
			background-color: #0c8b97;
			margin: 1rem;
		}
		.btn1 {
			cursor: pointer;
			width: 6rem;
			height: 2.5rem;
			font-size: .8rem;
			color: #fff;
			border: 0;
			/* border-radius: 5px; */
			margin: 0 1rem;
		}
		.btnx {
			background-color: #0c8b97;
		}
		
		.btn2 {
			background-color: #f48d28;
		}
		
		.warp_daochu{
			border-top: 1px solid rgb(232, 232, 232);
			display: flex;
			justify-content: space-between;
			padding: 1rem .5rem ;
		
			div{
				font-size: .7rem;
			}
		}
	}

</style>
<template>
	<div id='handhome-est'>
		<a-modal
		:width='island=="messagelist"||island=="handitemjiaban"?"47rem":"47rem"'
		id='main-handhomes-est'
		title='title'
		v-model='visible'
		@on='handleOk'
		@cancel='handleCancel'
		:footer="null" 
		:dialog-style="{ top: '22vh' }"
		:keyboard='false'
		:maskClosable='false'>
			<div class='main-hand-title'>
				<div style="position: relative;top: .44rem;font-size: .95rem;">更多操作</div>
			</div>
			<div style="display: flex;">
				<!-- (itemobj.schedule == 4 && itemobj.status == 0 && !itemobj.aduit)||(itemobj.status == 2)?titlearr1: -->
				<div v-for='(item,ind) in titlearr' 
				:key='ind + "0716"' v-if='!item.ishand'
				:class='island == item.component?"wland":"gland"' @click="fanfn(item)">
					{{item.name}}</div>
				<div v-if='itemobj.inviter' style="margin-left: auto;font-size: 0.8rem;padding: 0.6rem 0;color: #000000;"
				>邀請編號 : {{itemobj.inviter}}</div>
			</div>
			<div id='tubody-mainsk'>
				<component :is='island' :aduits='aduit' :ref='island' :applyid='applyid' @child="$emit('child', 1)" :record='itemobj'
				:form='form' :forms='forms' :picList = 'picList'></component>
			</div>
		</a-modal>
	</div>
</template>

<script>
	import homemessage from './homemessage.vue'
	import homeyuyue from './homeyuyue.vue'
	import shenheRecord from './shenheRecord.vue'
	import messagelist from './messagelist.vue'
	import handitemjiaban from './handitemjiaban.vue'
	import https from '@/plugins/http.js';
	import apiUrl from '@/assets/api.js';
	import shenhelist from './shenhelist.vue'
		
	export default {
		name:'handhome',
		props:['itemobj','applyid','forms','admintype'],
		components:{
			homemessage,messagelist,shenhelist,handitemjiaban,homeyuyue,shenheRecord
			},
		data(){
			return {
				aduit:true,
				tableData:[],
				picList:[],
				wjMessArr: [{
						label: "香港通行證正面",
						value: "HK_TW_MacaoPassimage",
						checked: true,
						imgUrl: require("@/image/wj_txz.png")
					},
					{
						label: "香港通行證背面",
						value: "HK_TW_MacaoPassimage2",
						checked: true,
						imgUrl: require("@/image/wj_txz.png")
					},
					{
						label: "大陸居民身份證正面",
						value: "identificationimage",
						checked: true,
						imgUrl: require("@/image/wj_sfzOn.png")
					},
					{
						label: "大陸居民身份證背面",
						value: "identificationimage2",
						checked: true,
						imgUrl: require("@/image/wj_dlsfzOff.png")
					},
					{
						label: "護照",
						value: "passportimage",
						checked: true,
						imgUrl: require("@/image/wj_hz.png")
					},
					{
						label: "外國居民身份證正面",
						value: "identificationimage_foreign",
						checked: true,
						imgUrl: require("@/image/wj_sfzOn.png")
					},
					{
						label: "外國居民身份證背面",
						value: "identificationimage_foreign2",
						checked: true,
						imgUrl: require("@/image/wj_wgsfzOff.png")
					},
					{
						label: "香港居民身份證正面",
						value: "identificationimage_HK",
						checked: true,
						imgUrl: require("@/image/wj_sfzOn.png")
					},
					{
						label: "香港居民身份證背面",
						value: "identificationimage_HK2",
						checked: true,
						imgUrl: require("@/image/wj_hksfzOff.png")
					},
					{
						label: "地址證明文件",
						value: "addressimage",
						checked: true,
						imgUrl: require("@/image/wj_dz.png")
					},
					{
						label: "匯款單",
						value: "transferAccountsimage",
						checked: true,
						imgUrl: require("@/image/wj_hkd.png")
					},
				],
				isname: '申請假期',
				visible:true,
				island: 'messagelist',
				form:{},
				titlearr1:[
					{
						name:'審核記錄',
						component:'shenhelist',
						island:false,
						// ishand:true
					}],
				titlearr:[
					{
						name:'預約開戶',
						component:'homeyuyue',
						island:false
					},
					{
						name:'上傳文件',
						component:'homemessage',
						island:true
					},
					{
						name:'客戶信息',
						component:'messagelist',
						island:false
					},
					{
						name:'前台審核',
						component:'handitemjiaban',
						island:false
					},
					{
						name:'審核記錄',
						component:'shenheRecord',
						island:false
					},
					{
						name:'審核狀態',
						component:'shenhelist',
						island:false,
					},
				]
			}
		},
		created() {
			let _this = this
			setTimeout(()=>{
				if(_this.itemobj.status == 3||_this.itemobj.status == 2||(_this.itemobj.schedule == 4 && _this.itemobj.status == 0 && !_this.itemobj.aduit)){
					_this.island = 'shenhelist'
				}
			},100)
		},
		mounted() {
		this.moreEvent();
		console.log(this.admintype,'123123123');
		var shName = ''
		if (this.admintype == 'khadmin1') {
			shName = '客服審核'
		}
		if (this.admintype == 'khadmin2') {
			shName = '中台審核'
		}
		if (this.admintype == 'khadmin3') {
			shName = '後台審核'
		}
		if (this.admintype == 'khadmin4') {
			shName = '授權審批'
		}
		console.log(this.itemobj);
		if (this.itemobj.websiteflag == 0) {
			this.titlearr=[
				{
					name:'客戶信息',
					component:'messagelist',
					island:true
				},
				{
					name:'上傳文件',
					component:'homemessage',
					island:false
				},
				{
					name:shName,
					component:'handitemjiaban',
					island:false
				},
				{
					name:'審核記錄',
					component:'shenheRecord',
					island:false
				},
				{
					name:'審核狀態',
					component:'shenhelist',
					island:false,
				},
			]
		}else{
			this.titlearr=[
				// {
				// 	name:'預約開戶',
				// 	component:'homeyuyue',
				// 	island:true
				// },
				// {
				// 	name:'上傳文件',
				// 	component:'homemessage',
				// 	island:false
				// },
				{
					name:'客戶信息',
					component:'messagelist',
					island:false
				},
				{
					name:shName,
					component:'handitemjiaban',
					island:false
				},
				{
					name:'審核記錄',
					component:'shenheRecord',
					island:false
				},
				{
					name:'審核狀態',
					component:'shenhelist',
					island:false,
				},
			];
			this.island = 'messagelist'
		}
		},
		watch:{
			itemobj:{
				deep:true,
				immediate:true,
				handler(ev){}
			},
		},
		methods:{
			moreEvent(record=this.itemobj){
			    let _this = this;
			 //    if(record.schedule == 4 && record.status == 0 && !record.aduit){
			 //        App.oTool.warningT("開戶審核已完成");
			 //        return;
			 //    }
			 //    if(record.status == 2){
			 //        App.oTool.warningT("開戶審核已取消");
			 //        return;
			 //    }
				// if(record.websiteflag != 0 && record.finishflag ==1 &&_this.forms.admintype =='khadmin1'){
				//     App.oTool.warningT("沒有可用操作");
				//     return;
				// }
				
			    if(!record.moreShowBol){
			        let json = {
			            token : _this.$store.state.token,
			        }
			        https.fetchPost(apiUrl.getOpeningList,{
			            id:record.pdfcode
			        },json).then((data) => {
			            if(Object.is(data.qmiscode,1000)){
			                this.aduit = data.aduit;
							this.picList = data.picList
			                // record.moreShowBol = true;
			            }else{
			                App.oTool.warningT(data.qmismsg);
			            }
			        }).catch(err => {
			            console.log(err);
			        });
			    }else{
					//二级弹窗
					_this.visible_bold = false;
					//关闭一级弹窗
			        record.moreShowBol = false;
			    }
			},
			fanfn(item){
				let record=this.itemobj;
				   if(record.schedule == 4 && record.status == 0 && !record.aduit){
					   this.$message.warning('開戶審核已完成')
				       return;
				   }
				   if(record.status == 3){
					   this.$message.warning('開戶審核已完成')
				       return;
				   }
				   if(record.status == 2){
					   this.$message.warning('開戶審核已取消')
				       return;
				   }
				console.log(this.island)
				if(item.component == 'shenhelist'){
				 	 this.getdata(item)
				}else if(item.component =='homemessage'){
					// if(this.picList.length == 0){
					// 	this.$message.warning('暫無下載文件')
					// }else{
						this.island = item.component;
					// }
				}else{
					this.island = item.component;
				}
					// this.isname = item.name;
			},
			
			getdata(item,record = this.itemobj) {
				this.tableData = []
				let _this = this;
				let json = {
					token: _this.$store.state.token,
				}
				https.fetchPost(apiUrl.getAdminRemarks, {
					admintype: _this.forms.admintype,
					token: json.token,
					id: record.pdfcode
				}, json).then((data) => {
					if (Object.is(data.qmiscode, 1000)) {
						this.tableData = data.remarks
						if(data.remarks.length == 0){
							this.$message.warning('暫無審核狀態')
						}else{
							this.island = item.component;
						}
					} else {
						// this.$message.warning(data.qmismsg)
					}
				}).catch(err => {
					// console.log(err);
				});
			},
			handleOk(){
				
			},
			handleCancel(){
				this.$emit('child', 0)
			},
		}
	}
</script>
